export const queryKeys = {
  REGION_TROUBLES: "region-troubles",
  REGION_DETAILED_TROUBLE: "region-detailed-trouble",
}